import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const LiveApi = ApiCore(globalDomains.LIVE_AFREECATV);
export default LiveApi;
